import { createReducer, on } from '@ngrx/store'
import { EbCartModification } from '../../interface/eb-cart.interface'
import * as actions from '../actions'

export const initialState: EbCartModification[] = []

export const ebCartModificationsReducer = createReducer(
  initialState,
  on(actions.setCartModifications, (_state, { result }) => [...result.cartModifications])
)
